import { render, staticRenderFns } from "./content5.vue?vue&type=template&id=6df12828&"
import script from "./content5.vue?vue&type=script&lang=js&"
export * from "./content5.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports